module.exports = __webpack_public_path__ + "static/media/HanWangMingBold.ed56dfae.svg";